import updateObject from "../../util/updateObject";
import * as actionTypes from "./actionTypes";
import {initialOperatorsTable} from "./helper";

const initialState = {
    operatorsTable: initialOperatorsTable,
};
const setOperatorsTable = (state, action) => updateObject(state, {
    operatorsTable: updateObject(
        state.operatorsTable,
        {[action.key]: action.value},
    ),
});

const operatorManagementReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_OPERATOR_MANAGEMENT_TABLE:
            return setOperatorsTable(state, action)
        default:
            return state;
    }
};

export default operatorManagementReducer;